import React from "react";
import { Link } from "react-router-dom";

const LegalLayout = ({ title, children }) => (
  <div className="min-h-screen bg-[#0A0A0A] text-gray-300 font-sans selection:bg-[#00FF41] selection:text-black">
    <nav className="border-b border-white/5 bg-black/50 backdrop-blur-xl sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center space-x-3 group">
          <div className="w-10 h-10 bg-gradient-to-br from-[#00FF41] to-[#008F22] rounded-xl flex items-center justify-center group-hover:rotate-12 transition-transform duration-300 shadow-[0_0_20px_rgba(0,255,65,0.2)]">
            <span className="text-black font-black text-xl">NR</span>
          </div>
          <span className="text-xl font-bold tracking-tighter bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-400">
            NORESPECT<span className="text-[#00FF41]">DIGITAL</span>
          </span>
        </Link>
        <Link to="/" className="text-sm font-medium hover:text-[#00FF41] transition-colors">
          Back to Home
        </Link>
      </div>
    </nav>

    <div className="max-w-4xl mx-auto px-6 py-20">
      <div className="space-y-8">
        <h1 className="text-5xl font-black text-white tracking-tight uppercase">
          {title}
        </h1>
        <div className="text-gray-400 space-y-4">
          {children}
        </div>
      </div>
    </div>

    <footer className="border-t border-white/5 py-12 bg-black">
      <div className="max-w-7xl mx-auto px-6 text-center text-sm text-gray-500">
        &copy; {new Date().getFullYear()} NoRespectDigital. All rights reserved.
      </div>
    </footer>
  </div>
);

const Privacy = () => {
  return (
    <LegalLayout title="Privacy Policy">
      <section className="space-y-6">
        <p className="text-lg leading-relaxed">
          At NoRespectDigital, we are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">1. Information We Collect</h2>
        <p>
          We collect personal information that you voluntarily provide to us when you register on the Site, express an interest in obtaining information about us or our products, or when you contact us.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">2. How We Use Your Information</h2>
        <p>
          We use personal information collected via our Site for a variety of business purposes, including: to facilitate account creation and logon process, to send administrative information to you, and to fulfill and manage your orders via our payment partner Paddle.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">3. Sharing Your Information</h2>
        <p>
          We only share information with your consent, to comply with laws, to provide you with services, to protect your rights, or to fulfill business obligations. This includes sharing data with Paddle for payment processing and Shopify for automation integrations.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">4. Security of Your Information</h2>
        <p>
          We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that no security measures are perfect or impenetrable.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">5. Data Retention</h2>
        <p>
          We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy policy, unless a longer retention period is required or permitted by law.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">6. Your Privacy Rights</h2>
        <p>
          Depending on your location, you may have certain rights regarding your personal data, including the right to access, correct, or delete the information we hold about you.
        </p>

        <p className="pt-10 text-sm italic">
          Last updated: April 15, 2026
        </p>
      </section>
    </LegalLayout>
  );
};

export default Privacy;
